import * as React from "react";

import { TextField, MenuItem } from "@material-ui/core";
import { useInput } from "react-admin";
import { useTranslate } from "react-admin";

const getMessage = (error) =>
  error && typeof error === "string"
    ? { message: error, args: undefined }
    : error && error.args
    ? { message: error.message, args: error.args }
    : { message: "", args: undefined };

const BoundedSelectInput = (props) => {
  const translate = useTranslate();
  const {
    input,
    meta: { touched, error },
    isRequired,
  } = useInput(props);
  const { allowEmpty, disabled, fullWidth, variant } = props;
  const errorMessage = getMessage(error);
  const message = translate(errorMessage.message, errorMessage.args);
  const choices = allowEmpty
    ? [{ id: undefined, name: undefined }, ...props.choices]
    : props.choices;

  return (
    <TextField
      select
      label={props.label}
      margin="dense"
      variant={variant}
      fullWidth={fullWidth}
      error={!!(touched && message)}
      helperText={touched && message}
      required={isRequired}
      disabled={disabled}
      {...input}
    >
      {choices?.map((itm) => (
        <MenuItem key={itm.id} value={itm.id}>
          {itm.name ? itm.name : <span>&nbsp;</span>}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default BoundedSelectInput;
